<template>
  <div class="row">
    <div
      v-if="!loader"
      class="col-12 navbar navbar-expand-lg navbar-light bg-light shadow-sm p-2 bg-white rounded"
    >
      <a class="navbar-brand" href="https://www.groovit.be/">
        <img :src="require('../assets/logo.png')" alt="logo">
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <input
          v-model="search"
          class="col-4 ml-auto form-control"
          type="search"
          placeholder="Rechercher"
        >
        <button v-on:click="disconnect()" type="button" class="btn btn-danger ml-3">
          <i class="fas fa-power-off fa-xs"></i>
        </button>
      </div>
    </div>
    <table v-if="!loader" class="table table-bordered table-hover">
      <thead class="thead-light">
        <tr>
          <th v-on:click="sort('ident')" class="hoverable">Numéro</th>
          <th v-on:click="sort('ownerFullName')" class="hoverable">Propriétaire</th>
          <th v-on:click="sort('thirdname')" class="hoverable">Client/Prospect</th>
          <th v-on:click="sort('displayedDate')" class="hoverable">Date</th>
          <th v-on:click="sort('subject')" class="hoverable">Objet</th>
          <th
            v-on:click="sort('totalAmountTaxesFree')"
            class="hoverable text-center"
            style="min-width: 100px"
          >
            <div>{{totalTaxesFree.toLocaleString()}}€</div>
            <div>Montant HT</div>
          </th>
          <th v-on:click="sort('ratio')" class="hoverable">Signature</th>
          <th
            v-on:click="sort('totalAmountTaxesFreeRatio')"
            class="hoverable text-center"
            style="min-width: 150px"
          >
            <div>{{totalTaxesFreeRatio.toLocaleString()}}€</div>Montant HT calculé
          </th>
          <th>Versements</th>
          <th
            v-for="i in 6"
            :key="i"
            v-on:click="sortByMonth(i)"
            class="hoverable text-center"
            style="min-width: 100px"
          >
            <div v-if="i == 1">
              <button v-on:click="monthBackward()" type="button" class="btn">
                <i class="fas fa-chevron-left"></i>
              </button>
            </div>
            <div v-if="i == 6">
              <button v-on:click="monthForward()" type="button" class="btn">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
            <div>{{getTotalForMonth(i).toLocaleString()}}€</div>
            <div>{{getTextMonth(getMonth(i)) + ' ' + (getYear(i) > 2000 ? getYear(i) - 2000 : getYear(i) - 1900) }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="estimate in estimatesFiltered"
          :key="estimate.ident"
          :class="estimate.ratio > 0 ? '' : 'table-danger'"
        >
          <td v-on:click="goTo(estimate.publicLinkShort)" class="hoverable">
            <u>{{estimate.ident}}</u>
          </td>
          <td>{{estimate.ownerFullName.split(' ')[0] + ' ' + estimate.ownerFullName.split(' ')[1][0] + '.'}}</td>
          <td>{{estimate.thirdname}}</td>
          <td>{{formatDate(estimate.displayedDate)}}</td>
          <td>{{estimate.subject}}</td>
          <td>{{estimate.totalAmountTaxesFree.toLocaleString()}}€</td>
          <td style="min-width:115px">
            <div class="input-group mb-3">
              <input
                v-model="estimate.ratio"
                v-on:change="updateRatio(estimate)"
                v-on:input="limitPercent(estimate, 'ratio')"
                v-on:focus="estimate.blocked = true"
                v-on:blur="estimate.blocked = false"
                type="number"
                class="form-control"
                min="0"
                max="100"
              >
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </td>
          <td>{{estimate.ratio > 0 ? estimate.totalAmountTaxesFreeRatio.toLocaleString() + '€' : ''}}</td>

          <td>
            <button
              v-if="estimate.ratio > 0"
              v-on:click="estimate.blocked=true;currentEstimate=estimate"
              type="button"
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#modalDate"
            >
              <i class="fas fa-edit"></i>
            </button>
          </td>
          <td
            v-for="i in 6"
            :key="i"
          >{{getSpecifiedTotalForMonth(estimate,i) == 0 ? '' : getSpecifiedTotalForMonth(estimate,i).toLocaleString() + '€'}}</td>
        </tr>
      </tbody>
    </table>

    <loader v-if="loader"/>

    <update-date :estimate="currentEstimate" id="modalDate"></update-date>
  </div>
</template>

<script>
import axios from "axios";

import endpoints from "../endpoints";
import UpdateDate from "./UpdateDate.vue";
import Loader from "./Loader.vue";

export default {
  name: "Core",
  data() {
    return {
      estimates: [],
      currentEstimate: {
        date1: null,
        date2: null,
        date3: null,
        ratio_date1: null,
        ratio_date2: null,
        ratio_date3: null
      },
      loader: true,
      search: "",
      month1: new Date().getMonth(),
      year1: new Date().getFullYear(),
      intervalId: null
    };
  },
  computed: {
    totalTaxesFree() {
      if (this.estimatesFiltered.length != 0)
        return Number(
          this.estimatesFiltered
            .map(item => item.totalAmountTaxesFree)
            .reduce((a, b) => a + b)
            .toFixed(2)
        );
      else return 0;
    },
    totalTaxesFreeRatio() {
      if (this.estimatesFiltered.length != 0)
        return Number(
          this.estimatesFiltered
            .map(item => item.totalAmountTaxesFreeRatio)
            .reduce((a, b) => a + b)
            .toFixed(2)
        );
      else return 0;
    },
    estimatesFiltered() {
      if (this.search != "")
        return this.estimates.filter(
          item =>
            item.ident.toUpperCase().includes(this.search.toUpperCase()) ||
            item.ownerFullName
              .toUpperCase()
              .includes(this.search.toUpperCase()) ||
            item.thirdname.toUpperCase().includes(this.search.toUpperCase()) ||
            item.displayedDate
              .toUpperCase()
              .includes(this.search.toUpperCase()) ||
            item.subject.toUpperCase().includes(this.search.toUpperCase()) ||
            item.totalAmountTaxesFree
              .toString()
              .includes(this.search.toUpperCase()) ||
            item.totalAmountTaxesFreeRatio
              .toString()
              .includes(this.search.toUpperCase()) ||
            item.ratio.toString().includes(this.search.toUpperCase())
        );
      else return this.estimates;
    }
  },
  methods: {
    goTo(location) {
      window.open(location);
    },
    disconnect() {
      localStorage.token = null;
      this.$parent.refresh();
    },
    formatDate(displayedDate) {
      let date = new Date(displayedDate);
      return (
        String(new Date(date).getDate()).padStart(2, "0") +
        "/" +
        String(new Date(date).getMonth() + 1).padStart(2, "0") +
        "/" +
        new Date(date).getFullYear()
      );
    },
    getMonth(nb) {
      var month = this.month1;

      for (var i = 1; i < nb; i++)
        if (month == 11) month = 0;
        else month++;

      return month;
    },
    getYear(nb) {
      var month = this.month1;
      var year = this.year1;

      for (var i = 1; i < nb; i++)
        if (month == 11) {
          month = 0;
          year++;
        } else month++;

      return year;
    },
    getSpecifiedTotalForMonth(estimate, nb) {
      var date1 = new Date(estimate.date1);
      var date2 = new Date(estimate.date2);
      var date3 = new Date(estimate.date3);

      var total = 0;

      if (
        date1.getMonth() == this.getMonth(nb) &&
        date1.getFullYear() == this.getYear(nb)
      )
        total +=
          (estimate.totalAmountTaxesFreeRatio / 100) * estimate.ratio_date1;
      if (
        date2.getMonth() == this.getMonth(nb) &&
        date2.getFullYear() == this.getYear(nb)
      )
        total +=
          (estimate.totalAmountTaxesFreeRatio / 100) * estimate.ratio_date2;
      if (
        date3.getMonth() == this.getMonth(nb) &&
        date3.getFullYear() == this.getYear(nb)
      )
        total +=
          (estimate.totalAmountTaxesFreeRatio / 100) * estimate.ratio_date3;

      return Number(total.toFixed(2));
    },
    getTotalForMonth(nb) {
      if (this.estimatesFiltered.length != 0)
        return Number(
          this.estimatesFiltered
            .map(item => this.getSpecifiedTotalForMonth(item, nb))
            .reduce((a, b) => a + b)
            .toFixed(2)
        );
      else return 0;
    },
    monthBackward() {
      if (this.month1 == 0) {
        this.month1 = 11;
        this.year1 = this.year1 - 1;
      } else this.month1 = this.month1 - 1;
    },
    monthForward() {
      if (this.month1 == 11) {
        this.month1 = 0;
        this.year1 = this.year1 + 1;
      } else this.month1 = this.month1 + 1;
    },
    getTextMonth(month) {
      switch (month) {
        case 0:
          return "Jan";
        case 1:
          return "Fev";
        case 2:
          return "Mar";
        case 3:
          return "Avr";
        case 4:
          return "Mai";
        case 5:
          return "Jun";
        case 6:
          return "Jul";
        case 7:
          return "Aou";
        case 8:
          return "Sep";
        case 9:
          return "Oct";
        case 10:
          return "Nov";
        case 11:
          return "Dec";
      }
    },
    limitPercent(estimate) {
      if (estimate.ratio < 0 || estimate.ratio == "") estimate.ratio = 0;
      if (estimate.ratio > 100) estimate.ratio = 100;
      if (estimate.ratio.toString().startsWith("0"))
        estimate.ratio = Number(estimate.ratio.toString().split("0")[1]);
    },
    sort(key) {
      if (
        this.estimates[0][key] > this.estimates[this.estimates.length - 1][key]
      )
        this.estimates = this.estimates.sort((a, b) =>
          a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
        );
      else
        this.estimates = this.estimates.sort((a, b) =>
          a[key] > b[key] ? -1 : b[key] > a[key] ? 1 : 0
        );
    },
    sortByMonth(nb) {
      if (
        this.getSpecifiedTotalForMonth(this.estimates[0], nb) >
        this.getSpecifiedTotalForMonth(
          this.estimates[this.estimates.length - 1],
          nb
        )
      )
        this.estimates = this.estimates.sort((a, b) =>
          this.getSpecifiedTotalForMonth(a, nb) >
          this.getSpecifiedTotalForMonth(b, nb)
            ? 1
            : this.getSpecifiedTotalForMonth(b, nb) >
              this.getSpecifiedTotalForMonth(a, nb)
            ? -1
            : 0
        );
      else
        this.estimates = this.estimates.sort((a, b) =>
          this.getSpecifiedTotalForMonth(a, nb) >
          this.getSpecifiedTotalForMonth(b, nb)
            ? -1
            : this.getSpecifiedTotalForMonth(b, nb) >
              this.getSpecifiedTotalForMonth(a, nb)
            ? 1
            : 0
        );
    },
    formatApiEstimate(item) {
      return {
        ownerFullName: item.ownerFullName,
        thirdname: item.thirdname,
        displayedDate: item.displayedDate,
        ident: item.ident,
        subject: item.subject,
        totalAmountTaxesFree: Number(
          parseFloat(item.totalAmountTaxesFree).toFixed(2)
        ),
        totalAmountTaxesFreeRatio: Number(
          (item.ratio == null
            ? 0
            : (parseFloat(item.totalAmountTaxesFree) / 100) * item.ratio
          ).toFixed(2)
        ),
        publicLinkShort: item.publicLinkShort,
        ratio: item.ratio == null ? 0 : item.ratio,
        date1: item.date1,
        date2: item.date2,
        date3: item.date3,
        ratio_date1: item.ratio_date1 == null ? 0 : Number(item.ratio_date1),
        ratio_date2: item.ratio_date2 == null ? 0 : Number(item.ratio_date2),
        ratio_date3: item.ratio_date3 == null ? 0 : Number(item.ratio_date3),
        blocked: false
      };
    },
    updateRatio(estimate) {
      this.updateEstimate(
        estimate,
        updatedEstimate =>
          (estimate.totalAmountTaxesFreeRatio =
            updatedEstimate.totalAmountTaxesFreeRatio)
      );
    },
    updateEstimate(estimate, callback) {
      axios
        .put(
          endpoints.estimate + "/" + estimate.ident,
          {
            ratio: estimate.ratio,
            date1: estimate.date1,
            date2: estimate.date2,
            date3: estimate.date3,
            ratio_date1: estimate.ratio_date1,
            ratio_date2: estimate.ratio_date2,
            ratio_date3: estimate.ratio_date3
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token
            }
          }
        )
        .then(response => {
          callback(this.formatApiEstimate(response.data));
        });
    },
    getEstimates() {
      axios
        .get(endpoints.estimate, {
          headers: {
            Authorization: "Bearer " + localStorage.token
          }
        })
        .then(response => {
          response.data
            .map(item => this.formatApiEstimate(item))
            .sort((a, b) =>
              a.ident > b.ident ? 1 : b.ident > a.ident ? -1 : 0
            )
            .forEach(item => {
              var index = this.estimates.findIndex(
                elem => elem.ident == item.ident
              );
              if (index == -1) this.estimates.unshift(item);
              else if (!this.estimates[index].blocked) {
                this.estimates[index].ownerFullName = item.ownerFullName;
                this.estimates[index].thirdname = item.thirdname;
                this.estimates[index].displayedDate = item.displayedDate;
                this.estimates[index].ident = item.ident;
                this.estimates[index].subject = item.subject;
                this.estimates[index].totalAmountTaxesFree =
                  item.totalAmountTaxesFree;
                this.estimates[index].totalAmountTaxesFreeRatio =
                  item.totalAmountTaxesFreeRatio;
                this.estimates[index].publicLinkShort = item.publicLinkShort;
                this.estimates[index].ratio = item.ratio;
                this.estimates[index].date1 = item.date1;
                this.estimates[index].date2 = item.date2;
                this.estimates[index].date3 = item.date3;
                this.estimates[index].ratio_date1 = item.ratio_date1;
                this.estimates[index].ratio_date2 = item.ratio_date2;
                this.estimates[index].ratio_date3 = item.ratio_date3;
              }
            });
          this.loader = false;
        })
        .catch(() => {
          this.$parent.refresh();
        });
    }
  },
  mounted() {
    this.loader = true;
    this.search = "";
    this.getEstimates();
    this.intervalId = window.setInterval(() => {
      this.getEstimates();
    }, 10000);
  },
  destroyed() {
    window.clearInterval(this.intervalId);
  },
  components: {
    UpdateDate,
    Loader
  }
};
</script>

<style scoped>
.hoverable {
  cursor: pointer;
}
table {
  font-size: 0.8rem;
}
th {
  position: sticky;
  top: 0;
  z-index: 10;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
